
/* injects from baggage-loader */

'use strict';

export default class PageFourController {
    constructor($log, $state, $timeout, $interval, Session, Dialog) {
        'ngInject'; 
        this.$log = $log;  
        this.$state = $state;
        this.$timeout = $timeout;
        this.$interval = $interval;
        this.Session = Session;
        this.Dialog = Dialog;
        this.step = 0;
        this.page = 1;
        this.passPage = true;
    }

    $onInit(){
        this.embeddeds = {
            fazDeConta: require('_images/page-four/Saiba-mais_faz-de-conta.png'),
            cabraCega: require('_images/page-four/Saiba-mais_cabra-cega.png'),
            amarelinha: require('_images/page-four/Saiba-mais_amarelinha.png'),
            gamesDigitais: require('_images/page-four/Saiba-mais_games-digitais.png'),
            main: require('_images/page-four/Caixa_brincadeiras.png'),
        }
    }

    nextPage(){
        this.step++;
        if(this.step>3)
            this.step = 0;
    }

    $onDestroy(){
        this.resetStage();
    }
    
    resetStage() {        
        return false;
    }

    openModal(url){
        this.Dialog.showEmbedded(url)
    }

    redirectToStages(){
        this.$state.go("page-five");
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/page-four/page-four.controller.js